import { Checkbox, Input, Radio, Select } from '@chakra-ui/react'
import { ButtonChakra } from '@wow/button'
import { FormChakra as Form } from '@wow/form-control'
import { FormErrorChakra as FormError } from '@wow/form-error'
import { FormLabelChakra as FormLabel } from '@wow/form-label'
import { ModalChakra } from '@wow/modal'
import { SpinnerChakra } from '@wow/progress-indicator'
import { themeChakra } from '@wow/themes'
import styles from './styles'
import { colorsStyles } from './generalStyles'

const colors = {
  ...themeChakra.colors,
  colorsStyles
}

const textStyles = {
  ...themeChakra.textStyles,
}

const sizes = {
  ...themeChakra.sizes,
}



const components = {
  ...alert,
  Checkbox,
  Form,
  FormLabel,
  FormError,
  Input,
  Radio,
  Select,
  Button: ButtonChakra,
  Modal: ModalChakra,
  Spinner: SpinnerChakra,
}

const themeData = { colors, textStyles, components, sizes, styles }

export default themeData
